import HelpTooltip from './HelpTooltip.jsx'

/**
 * Donut ring showing weekly cap usage. Comments and reposts have caps.
 *
 * Props: caps = { comment: { used, limit, remaining }, repost: {...} }
 */
export default function CapsRing({ caps }) {
  if (!caps) return null
  return (
    <div className="flex items-center gap-4">
      <Ring label="Comments" used={caps.comment.used} limit={caps.comment.limit} colour="#3076E2" />
      <Ring label="Reposts" used={caps.repost.used} limit={caps.repost.limit} colour="#1D3557" />
      <HelpTooltip label="What are caps?">
        Comments cap at 5 a week, reposts at 3. Posts and inbounds have no cap.
      </HelpTooltip>
    </div>
  )
}

function Ring({ label, used, limit, colour }) {
  const pct = Math.min(100, Math.round((used / limit) * 100))
  const remaining = Math.max(0, limit - used)
  const radius = 18
  const circ = 2 * Math.PI * radius
  const offset = circ * (1 - pct / 100)
  return (
    <div className="flex items-center gap-2">
      <svg width="44" height="44" viewBox="0 0 44 44" className="-rotate-90">
        <circle cx="22" cy="22" r={radius} fill="none" stroke="#E0E1E3" strokeWidth="4" />
        <circle
          cx="22" cy="22" r={radius} fill="none"
          stroke={colour} strokeWidth="4"
          strokeDasharray={circ}
          strokeDashoffset={offset}
          strokeLinecap="round"
          style={{ transition: 'stroke-dashoffset 600ms cubic-bezier(0.34, 1.56, 0.64, 1)' }}
        />
      </svg>
      <div className="flex flex-col leading-tight">
        <span className="text-xs font-semibold text-brand-text">{remaining} <span className="text-brand-text-muted font-normal">/ {limit}</span></span>
        <span className="text-[10px] uppercase tracking-wider text-brand-text-muted">{label}</span>
      </div>
    </div>
  )
}
